export { default } from "./ProjectTile";
